import React from "react";
import IMAGES from "utils/constants/image";
import IconList from "components/IconList";
import UseCaseGrid from "components/UseCaseGrid";
import { SELL_ANYWHERE_LIST } from "utils/constants/stripe";
import { styles } from "./styles";

const Header = () => (
  <section className="w-100">
    <div className="w-100 w-50-ns fl">
      <div className="f3 f2-l fw6 mb2 mt0-ns tl lh-title w-90">
        Sell anywhere
      </div>
      <div className="f5 f4-l fw4 mt0-ns tl lh-copy pt2">
        Modern consumers are in all channels, not just one. Payment links are
        global and omnichannel ready, allowing you to drive higher revenue by
        using them to sell in any channel.
      </div>
      <div className="f5 f4-l fw4 mb3 mt0-ns tl lh-copy pt2">
        Wherever your customers are in their purchasing journey, payment links
        can help you incentivize and close more sales with less friction.
      </div>
      <div className="w-100">
        <IconList
          list={SELL_ANYWHERE_LIST}
          size={22}
          customClasses={{ copy: "f6 f5-l pl2 lh-copy" }}
        />
      </div>
    </div>
    <div className="w-100 w-50-ns pt3 pt0-l fl pl0 pl4-ns">
      <div className={`${IMAGES.STATISTIC_RPU}--wrapper`}>
        <div className={`${IMAGES.STATISTIC_RPU}--img contain contain`} />
      </div>
    </div>
    <UseCaseGrid />
    <style jsx>{styles}</style>
  </section>
);

export default Header;
